
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tylenolautism",
      function () {
        return require("private-next-pages/tylenolautism/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tylenolautism"])
      });
    }
  